import { render, staticRenderFns } from "./FinancesInvoices.vue?vue&type=template&id=88cb835e&scoped=true&"
import script from "./FinancesInvoices.vue?vue&type=script&lang=js&"
export * from "./FinancesInvoices.vue?vue&type=script&lang=js&"
import style0 from "./FinancesInvoices.vue?vue&type=style&index=0&id=88cb835e&prod&lang=scss&"
import style1 from "./FinancesInvoices.vue?vue&type=style&index=1&id=88cb835e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cb835e",
  null
  
)

export default component.exports